import styled from 'styled-components';
import { rem } from 'polished';
var ImageContainer = styled.div.withConfig({
  displayName: "ImageContainer",
  componentId: "sc-14x6vtw-0"
})(["align-items:center;display:flex;margin:", " 0 ", ";max-width:", ";min-height:", ";"], rem(40), rem(32), function (_ref) {
  var imageWidth = _ref.imageWidth;
  return imageWidth ? rem(imageWidth) : rem(300);
}, function (_ref2) {
  var imageWidth = _ref2.imageWidth;
  return imageWidth ? rem(imageWidth * 1.2) : rem(300 * 1.2);
});
export default ImageContainer;